export default __webpack_public_path__ + "static/media/Podcast-banner.94602112.jpg";